import { render, staticRenderFns } from "./ContractCustomerOriginReport.vue?vue&type=template&id=52471758&"
import script from "./ContractCustomerOriginReport.vue?vue&type=script&lang=js&"
export * from "./ContractCustomerOriginReport.vue?vue&type=script&lang=js&"
import style0 from "./ContractCustomerOriginReport.vue?vue&type=style&index=0&id=52471758&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports